import React, { useState, useEffect, useRef } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";
import axios from "axios";
import { Link } from "react-scroll";

import Music from "../../assets/music.svg";
import MiLogo from "../../assets/moodLogo.png";
import Elipes from "../../assets/about_elip.svg";

import First_slider from "../../assets/slider/bigOne.png";
import Second_slider from "../../assets/slider/bigTwo.png";
import Third_slider from "../../assets/slider/bigThree.png";
import Four_slider from "../../assets/slider/bigFour.png";
import Five_slider from "../../assets/slider/bigFive.png";
import Six_slider from "../../assets/slider/bigSix.png";

import Errow_l from "../../assets/errow_l.svg";
import Errow_r from "../../assets/errow_r.svg";
import AboutLine from "../../assets/about_line.svg";
import AboutMain from "../../assets/about_main.svg";
import Cash from "../../assets/prizes/cash.svg";
import Stage from "../../assets/prizes/stage.svg";
import Festival from "../../assets/prizes/festival.svg";
import Guitar from "../../assets/prizes/guitar.svg";
import Phone from "../../assets/prizes/phone.svg";
import Schedule_cash from "../../assets/prizes/schedule.svg";
import Shilong from "../../assets/shilong.svg";
import Mumbai from "../../assets/mumbai.svg";
import Pune from "../../assets/pune.svg";
import Bangalore from "../../assets/banglore.svg";
import Delhi from "../../assets/delhi.svg";
import Cross from "../../assets/Cross.png";

import One from "../../assets/partners/one.svg";
import Two from "../../assets/partners/two.svg";
import Three from "../../assets/partners/three.svg";
import Four from "../../assets/partners/four.svg";

import SomeGood from "../../assets/partners/some_good.png";
import Bluethree from "../../assets/partners/Bluetree.png";
import Merchant from "../../assets/partners/merchant.png";
import KATHA from "../../assets/partners/KATHA.jpg";
import SBRS from "../../assets/partners/SBRS.jpg";
import BAY from "../../assets/partners/BAY.jpg";
import Stu from "../../assets/partners/stu.png";

import Schedule from "../../assets/schedule.svg";
import "./css/home.css";

const Home = () => {
  const [formVisible, setFormVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeSlide, setActiveSlide] = useState(0);

  const images = [
    { src: First_slider, alt: "First", title: "PARIKRAMA" },
    { src: Second_slider, alt: "Second", title: "PENTAGRAM" },
    { src: Third_slider, alt: "Third", title: "KRAKEN" },
    { src: Four_slider, alt: "Four", title: "THE F16S" },
    { src: Five_slider, alt: "Five", title: "BHAYANAK MAUT" },
    { src: Six_slider, alt: "Six", title: "SMALLTALK" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1)); // Wrap around at the end
    }, 3000); // 3 seconds interval

    return () => clearInterval(interval);
  }, [images.length]);

  const getVisibleImages = () => {
    if (activeSlide === 0) {
      return [
        images[images.length - 1],
        images[activeSlide],
        images[activeSlide + 1],
      ];
    } else if (activeSlide === images.length - 1) {
      return [images[activeSlide - 1], images[activeSlide], images[0]];
    } else {
      return [
        images[activeSlide - 1],
        images[activeSlide],
        images[activeSlide + 1],
      ];
    }
  };

  const visibleImages = getVisibleImages();

  const [formData, setFormData] = useState({
    band_name: "",
    city: "",
    genre: "",
    email: "",
    past_achievements: "",
    no_of_members: 0,
    leader_name: "",
    leader_contact: "",
    backup_contact: "",
    original_composition: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Collect missing fields in an array
    let missingFields = [];

    if (!formData.band_name) missingFields.push("Band Name");
    if (!formData.city) missingFields.push("City");
    if (!formData.genre) missingFields.push("Genre");
    if (!formData.email) missingFields.push("Email ID");
    if (!formData.past_achievements) missingFields.push("Past Achievements");
    if (!formData.no_of_members) missingFields.push("Number of Members");
    if (!formData.leader_name) missingFields.push("Leader Name");
    if (!formData.leader_contact) missingFields.push("Leader Contact");
    if (!formData.backup_contact) missingFields.push("Backup Contact");
    if (!formData.original_composition)
      missingFields.push("Original Composition Link");

    // If any field is missing, show an alert and return
    if (missingFields.length > 0) {
      alert(`Please fill the following fields: ${missingFields.join(", ")}`);
      return;
    }

    // Proceed with form submission if all fields are filled
    try {
      const response = await axios.post(
        "https://ashish.moodi.org/livewire/livewire_reg",
        formData
      );
      if (response.status === 200) {
        alert("Registration successful!");
        window.location.reload();
      }
    } catch (error) {
      console.error("There was an error submitting the form!", error);
    }
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const svgRef = useRef(null);

  const handleGetTicketClick = () => {
    
  };

  const handleCloseformClick = () => {
    setFormVisible(false);
  };
  return (
    <div style={{ overflowX: "hidden" }}>
      <div class="navbar">
        <div class="mi-logo">
          <Link to="page1" smooth={true} duration={500}>
            <img src={MiLogo} alt="" class="logo" />
          </Link>
        </div>
        <div class="nav-icons">
          <Link to="page2" smooth={true} duration={500}>
            <div className="nav-icon">about us</div>
          </Link>
          <Link to="page3" smooth={true} duration={500}>
            <div className="nav-icon">past winners</div>
          </Link>
          <Link to="page4" smooth={true} duration={500}>
            <div className="nav-icon">prizes</div>
          </Link>
          <Link to="page5" smooth={true} duration={500}>
            <div className="nav-icon">schedule</div>
          </Link>
          <Link to="page6" smooth={true} duration={500}>
            <div className="nav-icon">partners</div>
          </Link>
        </div>
        <div class="register-btn">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button class="register">REGISTER</button>
          </a>
        </div>
      </div>

      <div class="arrow">
        <div class="arrow-head active"></div>
        <div class="arrow-head"></div>
        <div class="arrow-head active"></div>
        <div class="arrow-head"></div>
        <div class="arrow-head active"></div>
        <div class="arrow-head"></div>
        <div class="arrow-head active"></div>
        <div class="arrow-head"></div>
        <div class="arrow-head active"></div>
        <div class="arrow-head"></div>
        <div class="arrow-head active"></div>
        <div class="arrow-head"></div>
      </div>

      <div className="page-1-bg" id="page1">
        <div className="page-1">
          <div className="page1-text-container">
            <div className="sub-head">MOOD INDIGO, IIT BOMBAY'S</div>
            <div className="main-head">LIVEWIRE</div>
            <div className="margin-div"></div>
            <div className="sub-head">
              INDIA'S LARGEST AND OLDEST SEMI-PRO BAND COMPETITION
            </div>
          </div>
        </div>
      </div>

      <div className="page-2" id="page2">
        <img src={Elipes} alt={Elipes} className="about_elips" />
        <div className="about_main">
          <img src={AboutMain} alt={AboutMain} />
        </div>
        <img src={AboutLine} alt={AboutLine} className="about_line" />
        <div className="heading_container">
          <div className="about_heading">
            <div className="abo_head_main">
              {windowWidth > 500 ? (
                <>
                  <p>ABOUT</p>
                  {windowWidth > 800 && <p>LIVEWIRE</p>}
                </>
              ) : (
                <p>ABOUT LIVEWIRE</p>
              )}
            </div>
            <div className="abo_head_main_b">
              <p>IT’S TIME FOR YOU TO PARTICIPATE</p>
              <div class="register-btn">
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button class="register">REGISTER</button>
                </a>
              </div>
            </div>
          </div>
          <div className="abot_head_b">
            <p>
              LiveWire is the celebration of independent music in India and aims
              to bring out the most unique music from various parts of our
              nation
            </p>

            <p>
              Livewire has been instrumental in promoting the independent music
              scene in India for the past 40 years.
            </p>

            <p>
              Over the years, Livewire has seen the birth of some of the
              country's greatest bands.
            </p>
            <p>It’s your chance to participate and make the most of it!</p>
          </div>
        </div>
      </div>
      <div className="page-3" id="page3">
        <div className="page_main">
          <div className="page_th">
            <img
              src={images[activeSlide].src}
              alt={images[activeSlide].alt}
              className="winner_main"
            />
            <div className="winner_img_div">
              <img src={Errow_l} alt="errow" className="errow_l" />
              {visibleImages.map((image, index) => (
                <div key={index} className="small_image_container">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className={`small_image ${
                      activeSlide === index ? "active" : ""
                    }`} // Add 'active' class to highlight the current slide
                  />
                </div>
              ))}
              <img src={Errow_r} alt="errow" className="errow_l" />
            </div>
          </div>
          <div className="winner_head">
            <p className="winner_head_main">PAST WINNERS</p>
            <div className="winner_head_a">
              <div className="karen">
                <img src={Music} alt="music" className="music" />
                <p>{images[activeSlide].title}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-4" id="page4">
        <div className="page_details">
          <p className="prize_head">PRIZES</p>
          <div className="prize_main">
            <div className="prize_contained">
              <p className="cash_head">Cash Prize</p>

              <img src={Cash} alt="cash" className="cash" />
              <div>
                <p className="cash_head_a">Win cash prizes worth 1.3L</p>
              </div>
            </div>
            <div className="prize_contained">
              <p className="cash_head">MOOD INDIGO PERFORMANCE</p>
              <img src={Stage} alt="cash" className="cash" />
              <div>
                <p className="cash_head_a">
                  Get to perform at the Mood Indigo mainstage
                </p>
              </div>
            </div>
            <div className="prize_contained">
              <p className="cash_head">GEAR COUPONS</p>

              <img src={Guitar} alt="cash" className="cash" />
              <div>
                <p className="cash_head_a">
                  Get Gear coupons worth 1.2 Lakh INR from Futrados
                </p>
              </div>
            </div>
          </div>
          <div className="prize_main prize_main_b">
            <div className="prize_contained">
              <p className="cash_head">GIG PERFORMANCE BY BLUETREE</p>

              <img src={Festival} alt="cash" className="cash" />
              <div>
                <p className="cash_head_a">
                  Get a Paid Performance Slot at a gig by Bluetree
                </p>
              </div>
            </div>
            <div className="prize_contained">
              <p className="cash_head">Sony Music Publishing</p>

              <img src={Phone} alt="cash" className="cash" />
              <div>
                <p className="cash_head_a">
                  Studio time and mentoring session at Sony Music Publishing, Mumbai
                </p>
              </div>
            </div>
            <div className="prize_contained">
              <p className="cash_head">Universal Music India</p>

              <img src={Phone} alt="cash" className="cash" />
              <div>
                <p className="cash_head_a">
                  Studio time and an opportunity to audition before Universal Music India’s internal A&R team in Mumbai
                </p>
              </div>
            </div>
            <div className="prize_contained">
              <p className="cash_head">FREE STUDIO TIME IN YOUR CITY</p>
              <img src={Schedule_cash} alt="cash" className="cash" />
              <div>
                <p className="cash_head_a">
                  Studio time to record an entire Album
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-5" id="page5">
        <p className="pagefive_heading">Schedule Plan</p>
        <svg
          ref={svgRef}
          className="line"
          width="13"
          height="1026"
          viewBox="0 0 13 1026"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 98)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 294)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 490)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 686)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 882)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 1078)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 1274)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 1470)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 1666)"
            stroke="white"
          />
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            transform="matrix(1 0 0 -1 0 1862)"
            stroke="white"
          />
          <line
            x1="6.5"
            y1="0.5"
            x2="6.5"
            y2="85.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="881.5"
            x2="6.5"
            y2="1025.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="97.5"
            x2="6.50001"
            y2="281.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="293.5"
            x2="6.50001"
            y2="477.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="489.5"
            x2="6.50001"
            y2="673.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="685.5"
            x2="6.50001"
            y2="869.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="685.5"
            x2="6.50001"
            y2="1065.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="685.5"
            x2="6.50001"
            y2="1261.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="685.5"
            x2="6.50001"
            y2="1457.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="685.5"
            x2="6.50001"
            y2="1653.5"
            stroke="white"
            stroke-linecap="round"
          />
          <line
            x1="6.5"
            y1="685.5"
            x2="6.50001"
            y2="1849.5"
            stroke="white"
            stroke-linecap="round"
          />
        </svg>
        <div className="pagefive_main">
          <img src={Schedule} alt="schedule" className="scheduel" />
          <div className="shedule_container">
            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">DELHI</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <p></p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Delhi} alt={Delhi} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">SHILLONG</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Shilong} alt={Shilong} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">BANGALORE</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <p>REGISTRATIONS CLOSED</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Bangalore} alt={Bangalore} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">HYDERABAD</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Pune} alt={Pune} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">PUNE</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <p>REGISTRATIONS CLOSED</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Shilong} alt={Shilong} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">AHMEDABAD</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <p>REGISTRATIONS CLOSED</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Bangalore} alt={Bangalore} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">KOLKATA</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <p>TBA</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Pune} alt={Pune} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">MUMBAI</p>
                <div className="shedule_subhead">
                  <p>4th DECEMBER</p>
                  <p>TBA</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Mumbai} alt={Mumbai} className="shilong_img" />
            </div>
            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">GOA</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Bangalore} alt={Bangalore} className="shilong_img" />
            </div>

            <div className="shedule_main">
              <div className="shedule_contained">
                <p className="shedule_heading">REST OF INDIA</p>
                <div className="shedule_subhead">
                  <p>ONLINE</p>
                  <p>TBA</p>
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button class="register">GET TICKET</button>
                  </a>
                </div>
              </div>

              <img src={Pune} alt={Pune} className="shilong_img" />
            </div>
          </div>
        </div>
        {formVisible && (
          <div className="form-container" id="page6">
            <img
              onClick={handleCloseformClick}
              src={Cross}
              alt={Cross}
              className="cross"
            />
            <div className="rules-section">
              <p className="form_heading">Rules</p>
              <ul>
                <li>
                  The band should submit and perform only their original
                  compositions.
                </li>
                <li>
                  The entire sound should be produced live, and the use of
                  pre-recorded samples must be approved by the organizers.
                </li>
                <li>
                  There are no language and genre restrictions on the bands.
                </li>
              </ul>
              <hr className="vertical" />
              <div className="band-info">
                <p className="form_heading">BAND INFORMATION</p>
                <form onSubmit={handleSubmit}>
                  <div className="label_div">
                    <label className="rule_label">Name:</label>
                    <input
                      className="rule_input"
                      type="text"
                      placeholder="Band Name"
                      name="band_name"
                      value={formData.band_name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="label_div">
                    <label className="rule_label">City:</label>
                    <input
                      className="rule_input"
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder="city"
                    />
                  </div>

                  <div className="label_div">
                    <label className="rule_label">Genre:</label>
                    <input
                      className="rule_input"
                      type="text"
                      placeholder="Genre"
                      name="genre"
                      value={formData.genre}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="label_div">
                    <label className="rule_label">Mail ID:</label>
                    <input
                      className="rule_input"
                      type="email"
                      placeholder="email@gmail.com"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="label_div mob_live">
                    <label className="rule_label">Past Achievements:</label>
                    <textarea
                      className="rule_textarea"
                      placeholder="Past Achievements"
                      name="past_achievements"
                      value={formData.past_achievements}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </form>
              </div>
            </div>
            <hr className="horizontal" />
            <div className="form-section">
              <div className="members-info">
                <p className="form_heading">MEMBERS INFORMATION</p>
                <form onSubmit={handleSubmit}>
                  <div className="label_div">
                    <label className="member_label">Number of Members:</label>
                    <input
                      className="member_input"
                      type="number"
                      name="no_of_members"
                      value={formData.no_of_members}
                      onChange={handleChange}
                      placeholder="Contact Number"
                    />
                  </div>
                  <div className="label_div">
                    <label className="member_label">Leader Name:</label>
                    <input
                      className="member_input"
                      name="leader_name"
                      value={formData.leader_name}
                      onChange={handleChange}
                      type="text"
                      placeholder="Leader Name"
                    />
                  </div>
                  <div className="label_div">
                    <label className="member_label">Leader Contact:</label>
                    <input
                      className="member_input"
                      type="phoneNumber"
                      placeholder="Leader Contact"
                      name="leader_contact"
                      value={formData.leader_contact}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="label_div">
                    <label className="member_label">Backup Contact:</label>
                    <input
                      className="member_input"
                      type="phoneNumber"
                      placeholder="Contact Number"
                      name="backup_contact"
                      value={formData.backup_contact}
                      onChange={handleChange}
                    />
                  </div>
                  <label className="member_special">
                    Link for all original music like singles/albums (Please
                    separate by commas):
                  </label>
                  <textarea
                    className="member_textarea"
                    placeholder="Link of your composition"
                    name="original_composition"
                    value={formData.original_composition}
                    onChange={handleChange}
                  ></textarea>
                </form>
                <button
                  className="submit-btn"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="page-6" id="page6">
        <div className="page6_main">
          <p className="page_six_head">PARTNERS</p>
          <div className="partners_main">
            <div className="partners_details">
              <p className="partners_heading">Promotion Partner</p>
              <img src={SomeGood} alt={Two} className="partner-img" />
            </div>
            <div className="partners_details">
              <p className="partners_heading">Gig Partner</p>
              <img src={Bluethree} alt={One} className="partner-img" />
            </div>
            <div className="partners_details">
              <p className="partners_heading">Record Label Partner</p>
              <img src={Merchant} alt={Three} className="partner-img" />
            </div>
            <div className="partners_details">
              <p className="partners_heading">Tour Partner</p>
              <img src={Four} alt={Four} className="partner-img" />
            </div>
          </div>
        </div>
      </div>

      <div className="foot">
        <div className="foot-comp" id="27">
          <h3 className="foot-head">ADDRESS</h3>
          <p className="foot-cont">
            Mood Indigo Office,
            <br />
            Student Activity Centre,
            <br />
            IIT Bombay.
          </p>
        </div>

        <div className="foot-comp contact" id="33">
          <p className="foot-head">CONTACT</p>
          <div className="foot-cont">
            <p>
              Yog Sonawane: <a href="tel:+917977058957">+91 79770 58957</a>
            </p>
            <p>
              Ranbir Sinha <a href="tel:+919137622913">+91 91376 22913</a>
            </p>
          </div>
        </div>

        <div className="foot-comp" id="34">
          <h3 className="foot-head">E-MAIL</h3>
          <p className="foot-cont">
            <a href="mailto:yog@moodi.org">
              yog@moodi.org
            </a>
            <br />
            <a href="mailto:ranbir@moodi.org">ranbir@moodi.org</a>
          </p>
        </div>

        <div className="foot-comp" id="35">
          <h3 className="foot-head">FOLLOW US</h3>
          <div className="foot-logos">
            <a
              href="https://www.facebook.com/iitbombay.moodi"
              className="foot-logo"
              aria-label="Facebook"
            >
              <FaFacebookF
                size={window.innerWidth > 800 ? 40 : 20}
                color="white"
                className="foot_logo"
              />
            </a>
            <a
              href="https://www.instagram.com/iitbombay.moodi/"
              className="foot-logo"
              aria-label="Instagram"
            >
              <FaInstagram
                size={window.innerWidth > 800 ? 40 : 20}
                color="white"
                className="foot_logo"
              />
            </a>
            <a
              href="https://twitter.com/iitb_moodi?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              className="foot-logo"
              aria-label="Twitter"
            >
              <FaTwitter
                size={window.innerWidth > 800 ? 40 : 20}
                color="white"
                className="foot_logo"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/mood-indigo/mycompany/"
              className="foot-logo"
              aria-label="LinkedIn"
            >
              <FaLinkedin
                size={window.innerWidth > 800 ? 40 : 20}
                color="white"
                className="foot_logo"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
